<template>
  <div class="system-box">
    <el-form :model="form" ref="form" label-width="120px" >
      <el-form-item label="分站：">
        <el-select v-model="placeData[0]" clearable @change="remoteMethod($event,1)" placeholder="省">
          <el-option v-for="o in province" :key="o.id" :label="o.name" :value="o.id"></el-option>
        </el-select>
        <el-select v-model="placeData[1]" clearable @change="remoteMethod($event,2)" placeholder="市">
          <el-option v-for="o in city" :key="o.id" :label="o.name" :value="o.id"></el-option>
        </el-select><br />
        <el-select v-model="placeData[2]" clearable @change="remoteMethod($event,3)" placeholder="县">
          <el-option v-for="o in county" :key="o.id" :label="o.name" :value="o.id"></el-option>
        </el-select>
        <el-select style="margin:10px 0 0 0" v-model="placeData[3]" clearable @change="remoteMethod($event,4)" placeholder="镇">
          <el-option v-for="o in town" :key="o.id" :label="o.name" :value="o.id"></el-option>
        </el-select><br />
        <el-select style="margin:10px 0 0 0" v-model="placeData[4]" clearable @change="remoteMethod($event,5)" placeholder="村">
          <el-option v-for="o in village" :key="o.id" :label="o.name" :value="o.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="人社业务链接:">
        <el-input v-model="link"></el-input>
      </el-form-item>
      <el-form-item label="提交：">
        <el-button type="primary" @click="setData()">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import mixin_area from '@/Mixins/mixin_area'
export default {
  mixins: [ mixin_area ],
  data() {
    return {
      link:'',
      form: {},
      province: [],
      city: [],
      county: [],
      town: [],
      village: [],
      form: {},
      placeData: [],
    }
  },
  created() {
    this.areaGet({value: {areaId:0},key:0})
  },
  methods: {
    setData() {
      let place = []
      //过滤空字符串
      place = this.placeData.filter(x => x)
      if (place.length === 0) { return this.$message.info('请至少输入一个地区')}
      else if (this.link === '') { return this.$message.info('请输入人社业务链接！')}
      else {
        // 别人写的
        // this.$api.setRSLink({socialUrl:this.link,id:place[place.length-1]}).then(res =>{
        //   if (res.data.status === 0) { this.$message.success('设置成功！')}
        //   else if (res.data.status === 10) { this.$message.error('权限不够！')}
        //   else { this.$message.error('设置失败！')}
        // })
        let data = {}
        data.id = place[place.length-1]
        data.socialUrl = this.link
        this.$api.editSystemNameLogo(data).then(res => {
          res.data.status == 0 ? this.$message.success("设置成功!") : this._status(res.data)
          
        })
      }
    }
  }
}
</script>

<style scoped>
.system-box{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.system-box>div{
  margin-left: 20px;
}
</style>